module.exports = __webpack_public_path__ + "static/media/sell_take_order_make_3.fff73e41.jpg";